import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Growl } from 'primereact/growl';
import React, { Component } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { HttpService } from '../../service/HttpService';
import { checkForError, showMessage } from '../../utility/AppUtility';
import constant from './../../constant/Constant';
import { PriviladgeContext } from './../../context/priviladge-context'
import CheckPriviladge from './../../hoc/CheckPriviladge'
import { AppBreadcrumb } from '../../AppBreadcrumb';

export class RollList extends Component {

    constructor() {
        super();
        this.state = {
            dataTableValue: [],
            page: 1,
            totalRecords: 0,
            size: 100
        };

        this.httpService = new HttpService();
        this.codeType = [
            { label: 'Alphanumeric', value: 'Alphanumeric' },
            { label: 'Numeric', value: 'Numeric' }
        ]
        this.fontType = [
            { label: 'Times Roman', value: 'Times-Roman' },
            { label: 'Helvetica', value: 'Helvetica' },
            { label: 'Courier', value: 'Courier' }
        ]

    }


    componentDidMount() {

        this.getList(this.state.page - 1);
    }
    getList = (page) => {
        trackPromise(
            this.httpService.getApi('roll-details?page=' + page + "&size=" + this.state.size + "&sort=createdDate,desc").then((response) => {
                this.setState({ dataTableValue: response.data, totalRecords: response.data.totalElements });

            }).catch((error) => {
                if (checkForError(error))
                    this.showMessage('error', 'Error Message', error.response.data.title)
            }));
    }
    showMessage(severity, summary, message) {
        let msg = { severity: severity, summary: summary, detail: message };
        this.growl.show(msg);
    }
    onPageChange = (event) => {
        this.setState({ page: event.page })
        this.getList(event.page)

    }






    download = (rowData, ext) => {
        var a = document.createElement('a');
        a.href = constant.TEMPLATE_URl + rowData.fileName;
        a.download = rowData.fileName;
        a.click();
        a.remove();
    }
    sendForPrinting = (rowData) => {
        trackPromise(
            this.httpService.getApi('printingJob/storeftp/' + rowData.id).then((response) => {

            }).catch((error) => {
                if (checkForError(error))
                    this.showMessage('error', 'Error Message', error.response.data.title)
            }));
    }

    edit = (rowData) => {
        this.props.history.push({
            pathname: '/label_production_edit',
            state: { id: rowData.id }
        })
    }
    download = (rowData) => {
        var a = document.createElement('a');
        a.href = constant.TEMPLATE_URl + rowData.fileName;
        a.download = rowData.fileName;
        a.target = '_blank';
        a.click();
        a.remove();
    }


    actionTemplate = (rowData, column) => {
        return <div style={{ width: "110px" }}>
            <Button type="button" tooltip="Edit" tooltipOptions={{ position: 'bottom' }} icon="pi-md-pencil" className="p-button-warning" onClick={() => this.edit(rowData)} />
        </div>;
    }
    add = () => {
        this.props.history.push('label_production_add')
    }
    render() {
        let actionHeader = <Button type="button" icon="pi-md-settings" />;

        return <>
            <AppBreadcrumb breadcrumdItems={[{ label: 'Label Production List' }]} />
            <div className="p-grid">
                <div className="p-col-12">
                    <Growl ref={(el) => this.growl = el} style={{ marginTop: '75px' }} />

                    <div className="card card-w-title datatable-demo">
                        <div className="p-col-12">
                            <font className="font21Weight500" >Label Production List</font>

                            {/* <Button className="floatRight" icon="pi-md-plus"
                            tooltip="Add Label Production" label="Add" tooltipOptions={{ position: 'left' }} onClick={() => this.add()} /> */}

                        </div>
                        <div className="p-col-12">
                        </div>
                        <DataTable ref={(el) => this.dt = el} value={this.state.dataTableValue} header="List Of Label Production"
                            paginator={true} rows={10}
                            responsive={true} resizableColumns={true} columnResizeMode="fit"
                        >
                            <Column field="description" header="Description" sortable={true} filter={true} filterPlaceholder="Contains" />
                            <Column field="totalQuantity" header="Total Quantity" sortable={true} filter={true} filterPlaceholder="Contains" />
                            <Column field="rollQuantity" header="Roll Quantity" sortable={true} filter={true} filterPlaceholder="Contains" />
                            {/* <Column field="status" header="Status" sortable={true} filter={true} filterPlaceholder="Contains" /> */}


                            <Column header={actionHeader} body={this.actionTemplate} style={{ textAlign: 'center', width: '9em' }} />


                        </DataTable>

                    </div>
                </div>
            </div></>
    }
}